export default __webpack_public_path__ + "static/media/Discodick.fe305c77.PNG";